/* global axios */
import ApiClient from '../ApiClient';

class SocialMonitoringAlertsAPI extends ApiClient {
  constructor() {
    super('social_monitoring/alerts', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  list({ unread, level, profileId } = {}) {
    return axios.get(this.url, {
      params: { unread, level, profileId },
    });
  }

  acknowledge(id) {
    return axios.patch(`${this.url}/${id}/acknowledge`);
  }

  acknowledgeAll() {
    return axios.post(`${this.url}/acknowledge_all`);
  }
}

export default new SocialMonitoringAlertsAPI();
